import React, { useState } from "react";
import {
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Avatar,
    Typography,
    Button,
    IconButton,
    Menu,
    MenuItem,
    Pagination,
} from "@mui/material";
import { MoreHorizOutlined } from "@mui/icons-material";
import colors from "../styles/colors";

const columnStyle = { fontSize: 13, fontFamily: 'PSBo',color:colors.textPrimary };

const CustomDataTable = ({ pagination = true, data = [], columns = [], totalPages, currentPage, onPageChange }) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    return (
        <Box sx={{ width: "100%", overflowX: "auto", backgroundColor: colors.white, borderRadius: 5, }}>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            {columns.map((col, index) => (
                                <TableCell
                                    key={index} sx={columnStyle}>
                                    {col.label}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data?.length >0 && data?.map((row, rowIndex) => (
                            <TableRow key={rowIndex}>
                                {columns.map((col, colIndex) => (
                                    <TableCell
                                        sx={{ fontFamily: 'PMe', fontSize: 11 }}
                                        key={colIndex}>
                                        {col.render ? col.render(row[col.field], row) : row[col.field]}
                                    </TableCell>
                                ))}
                                {/* <TableCell>
                                    <IconButton onClick={handleMenuClick}>
                                        <MoreHorizOutlined />
                                    </IconButton>
                                </TableCell> */}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            {/* Pagination */}
            {
                pagination &&
                <Box sx={{ display: "flex", justifyContent: "center", marginTop: 2 }}>
                    <Pagination
                        count={totalPages}
                        page={currentPage}
                        onChange={(_, page) => onPageChange(page)}
                        variant="outlined"
                        shape="rounded"
                    />
                </Box>
            }
        </Box>
    );
};

export default CustomDataTable;



// import React, { useState } from "react";
// import {
//     Box,
//     Table,
//     TableBody,
//     TableCell,
//     TableContainer,
//     TableHead,
//     TableRow,
//     Avatar,
//     Typography,
//     Button,
//     IconButton,
//     Menu,
//     MenuItem,
// } from "@mui/material";
// import colors from "../styles/colors";
// import { MoreHorizOutlined } from "@mui/icons-material";

// const data = [
//     {
//         image: "https://i.pravatar.cc/300", // Replace with your image source
//         customer: { name: "Mughees Butt", id: 123 },
//         vehicle: "T 7278",
//         startDate: "2024-10-29",
//         expectedReturn: "2024-10-31",
//         returnDate: "1 Days",
//         finalTotal: "20 OMR",
//         paid: "10 OMR",
//         outstanding: "10 OMR",
//     },
//     {
//         image: "",
//         customer: { name: "ali", id: 1111111 },
//         vehicle: "T 2364",
//         startDate: "2024-10-27",
//         expectedReturn: "2024-10-29",
//         returnDate: "1 Days",
//         finalTotal: "5 OMR",
//         paid: "10 OMR",
//         outstanding: "-5 OMR",
//     },
//     {
//         image: "https://i.pravatar.cc/301",
//         customer: { name: "Mughees Butt", id: 123 },
//         vehicle: "T 32191",
//         startDate: "2024-10-04",
//         expectedReturn: "2024-10-10",
//         returnDate: "5 Days",
//         finalTotal: "50 OMR",
//         paid: "10 OMR",
//         outstanding: "40 OMR",
//     },
// ];


// const columnStyle = { color: colors.black, fontSize: 12, fontFamily: 'PMe' }

// const CustomDataTable = () => {


//     const [anchorEl, setAnchorEl] = useState(null);
//     const [selectedItem, setSelectedItem] = useState(null);


//     const handleClick = (event, item) => {
//         setAnchorEl(event.currentTarget);
//         setSelectedItem(item);
//     };

//     const handleClose = () => {
//         setAnchorEl(null);
//         setSelectedItem(null);
//     };





//     return (
//         <Box sx={{ width: "100%", overflowX: "auto", backgroundColor: colors.white, borderRadius: 5, marginTop: 3 }}>
//             <TableContainer>
//                 <Table>
//                     <TableHead>
//                         <TableRow>
//                             <TableCell sx={columnStyle} >Image</TableCell>
//                             <TableCell sx={columnStyle} >Customer</TableCell>
//                             <TableCell sx={columnStyle} >Vehicle</TableCell>
//                             <TableCell sx={columnStyle} >Start Date</TableCell>
//                             <TableCell sx={columnStyle} >Expected Return</TableCell>
//                             <TableCell sx={columnStyle} >Return Date</TableCell>
//                             <TableCell sx={columnStyle} >Final Total</TableCell>
//                             <TableCell sx={columnStyle} >Paid</TableCell>
//                             <TableCell sx={columnStyle} >Outstanding</TableCell>
//                             <TableCell sx={columnStyle} >Action</TableCell>
//                         </TableRow>
//                     </TableHead>
//                     <TableBody>
//                         {data.map((row, index) => (
//                             <TableRow key={index}>
//                                 <TableCell>
//                                     <Avatar src={row.image} />
//                                 </TableCell>
//                                 <TableCell>
//                                     <Typography sx={{ fontFamily: 'PMe', fontSize: 12, color: colors.black }}>{row.customer.name}</Typography>
//                                 </TableCell>
//                                 <TableCell>
//                                     <Button
//                                         variant="contained"
//                                         sx={{
//                                             backgroundColor: colors.carCardPlateBg, color: colors.textWhite, borderRadius: '10px',
//                                             padding: '5px 10px', fontFamily: 'PMe', marginTop: '7px', fontSize: 12
//                                         }}
//                                     >
//                                         {'TH'}
//                                         <Box
//                                             sx={{
//                                                 borderWidth: '1px',
//                                                 borderStyle: 'solid',
//                                                 borderColor: 'white',
//                                                 ml: 1,
//                                                 padding: '0px 5px',
//                                                 borderRadius: 2,
//                                                 fontSize: 12,

//                                             }}
//                                         >
//                                             {"181"}
//                                         </Box>
//                                     </Button>
//                                 </TableCell>
//                                 <TableCell>
//                                     <Typography sx={{ fontFamily: 'PMe', fontSize: 12 }} >{row.startDate}</Typography>
//                                 </TableCell>
//                                 <TableCell>
//                                     <Typography sx={{ fontFamily: 'PMe', fontSize: 12 }} >{row.expectedReturn}</Typography>
//                                 </TableCell>
//                                 <TableCell sx={{ fontFamily: 'PMe', fontSize: 12 }}>{row.returnDate}</TableCell>
//                                 <TableCell sx={{ fontFamily: 'PMe', fontSize: 12 }}>{row.finalTotal}</TableCell>
//                                 <TableCell>
//                                     <Box
//                                         sx={{
//                                             backgroundColor: row.paid === "10 OMR" ? "#FF5722" : "#4CAF50",
//                                             color: "#fff",
//                                             padding: "4px 8px",
//                                             borderRadius: "4px",
//                                             textAlign: "center",
//                                             fontFamily: "PMe",
//                                             fontSize: 12
//                                         }}
//                                     >
//                                         {row.paid}
//                                     </Box>
//                                 </TableCell>
//                                 <TableCell>
//                                     <Typography sx={{ fontFamily: 'PMe', fontSize: 12, fontSize: 12 }}>{row.outstanding}</Typography>
//                                 </TableCell>
//                                 <TableCell>
//                                     <Box
//                                         sx={{
//                                             display: 'flex',
//                                             justifyContent: 'flex-end',
//                                             padding: '0px',
//                                         }}
//                                     >
//                                         <IconButton onClick={(event) => handleClick(event, {})}>
//                                             <MoreHorizOutlined sx={{ color: colors.primary }} />
//                                         </IconButton>
//                                     </Box>
//                                 </TableCell>
//                             </TableRow>
//                         ))}
//                     </TableBody>
//                 </Table>
//             </TableContainer>



//             {/* Menu for More Options */}
//             <Menu
//                 anchorEl={anchorEl}
//                 open={Boolean(anchorEl)}
//                 onClose={handleClose}
//                 anchorOrigin={{
//                     vertical: 'top',
//                     horizontal: 'right',
//                 }}
//                 transformOrigin={{
//                     vertical: 'top',
//                     horizontal: 'right',
//                 }}
//             >
//                 <MenuItem
//                     sx={{ fontFamily: 'PMe', fontSize: 12, color: colors.textBlack }}
//                 >View </MenuItem>
//                 <MenuItem
//                     sx={{ fontFamily: 'PMe', fontSize: 12, color: colors.textBlack }}
//                 >Close</MenuItem>
//                 <MenuItem
//                     sx={{ fontFamily: 'PMe', fontSize: 12, color: colors.textBlack }}
//                 >Delete </MenuItem>
//                 <MenuItem
//                     sx={{ fontFamily: 'PMe', fontSize: 12, color: colors.textBlack }}
//                 >Print</MenuItem>
//             </Menu>
//         </Box>
//     );
// };

// export default CustomDataTable;
